// Constants
import { MENU_URL } from '@/constants'
// Components
import PlaceListItems from '../PlaceListItems'
import VuetifyDataTable from '@/components/ui/VuetifyDataTable'
// Mixins
import uiMixin from '@/mixins/uiMixin'
// Services
import { getManagedPlacesByPartnerId } from '@/services/partner'
// Vuex
import { mapGetters } from 'vuex'
// Filters
import { formatDate } from '@/filters'

export default {
  name: 'PlaceManagedList',
  components: {
    PlaceListItems,
    VuetifyDataTable
  },
  mixins: [uiMixin],
  data() {
    return {
      // Table
      headers: [
        {
          text: 'Establecimiento',
          value: 'name'
        },
        {
          text: 'Suscripción',
          value: 'package'
        },
        {
          text: 'Fecha',
          value: 'date'
        },
        {
          align: 'center',
          filterable: false,
          text: 'Ver carta'
        }
      ],
      items: [],
      processingRequest: true,
      search: '' // Usamos para buscar dentro de "dataTable"
    }
  },
  computed: {
    ...mapGetters('company', ['companyData'])
  },
  async mounted() {
    // Obtenemos los datos iniciales
    await this.getEveryNeededData()
  },
  methods: {
    /**
     * Cuando pulsamos sobre el icono de "menú"
     *
     * @param {string} id - id item
     */
    handleClickMenu(id) {
      // Abrimos menú en nueva pestaña
      window.open(`${MENU_URL}${id}`, '_blank')
    },
    /**
     * Obtenemos todos los datos necesarios para
     * inicializar el componente
     */
    async getEveryNeededData() {
      // Loading
      this.processingRequest = true
      try {
        // Obtenemos los datos de los establecimientos asociados
        this.items = await this.getItems(this.companyData.id)
      } catch (error) {
        // Muestras errores
        this.modifyAppAlert({
          type: 'error',
          text: error.message,
          visible: true
        })
      } finally {
        // Loading
        this.processingRequest = false
      }
    },
    /**
     * Obtenemos las compañías (establecimientos)
     * asociadas a la compañía
     *
     * @param {string} id - id de la compañía
     * @return {array} - array con datos de compañías
     */
    async getItems(id) {
      const items = await getManagedPlacesByPartnerId(id)
      return items.map((item) => {
        return {
          id: item.placeId,
          name: item.placeName,
          package: item.packageOnDate,
          date: formatDate(item.createTimestamp, 'D MMMM YYYY')
        }
      })
    }
  }
}
